import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const adminVendedoresApiClient = axios.create({
  withCredentials: true,
});

export const ADMIN_VENDEDOR_FORM_INITIAL_STATE = {
  nome: '',
  telefone: '',
  whatsapp: '',
  email: '',
  foto_url: '',
  especialidade: 'todos',
};

export const VENDEDOR_SPECIALTY_OPTIONS = [
  { value: 'todos', label: 'Todos os Serviços' },
  { value: 'casas', label: 'Casas / Imóveis' },
  { value: 'carros', label: 'Carros / Veículos' },
  { value: 'reformas', label: 'Reformas' },
];

export const fetchAdminVendedoresData = async () => {
  const [vendedoresRes, metricsRes] = await Promise.all([
    adminVendedoresApiClient.get(`${API}/vendedores`),
    adminVendedoresApiClient.get(`${API}/admin/vendedores/metrics`),
  ]);

  return {
    vendedores: vendedoresRes.data,
    metrics: metricsRes.data,
  };
};

export const createVendedor = async (formData) => {
  await adminVendedoresApiClient.post(`${API}/vendedores`, formData);
};

export const updateVendedor = async (vendedorId, formData) => {
  await adminVendedoresApiClient.put(`${API}/vendedores/${vendedorId}`, formData);
};

export const toggleVendedorStatus = async (vendedor) => {
  await adminVendedoresApiClient.put(`${API}/vendedores/${vendedor.id}`, { ativo: !vendedor.ativo });
};

export const deleteVendedor = async (vendedorId) => {
  await adminVendedoresApiClient.delete(`${API}/vendedores/${vendedorId}`);
};

export const fetchVendedorLeads = async (vendedorId) => {
  const response = await adminVendedoresApiClient.get(`${API}/vendedores/${vendedorId}/leads`);
  return response.data;
};

export const deleteLead = async (leadId) => {
  await adminVendedoresApiClient.delete(`${API}/admin/leads/${leadId}`);
};
